import { NgModule } from '@angular/core';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  API_BASE_URL,
  CoreModule,
  MDS_API_CONFIG_URL,
  MDS_TRANSLATE_LOADERS,
  MDS_TRANSLATE_PROVIDER,
} from '@mds/angular-core-material';
import { LayoutModule } from '@mds/angular-layout-material';
import { TranslateModule } from '@ngx-translate/core';
import { getApiBaseUrl, getApiConfigUrl, TVP_TOOLBAR_LOGO } from '@tvp/common';
import { ReplaySubject } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WebpackTranslateLoader } from './localization/translate-loader';
import { TvpCommonModule } from './modules/common/common.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    LayoutModule,
    TvpCommonModule,
    TranslateModule.forRoot({
      loader: MDS_TRANSLATE_PROVIDER,
    }),
    AppRoutingModule,
  ],
  providers: [
    { provide: MDS_API_CONFIG_URL, useFactory: getApiConfigUrl },
    { provide: API_BASE_URL, useFactory: getApiBaseUrl },
    { provide: TVP_TOOLBAR_LOGO, useValue: new ReplaySubject<string>() },
    {
      provide: MDS_TRANSLATE_LOADERS,
      useClass: WebpackTranslateLoader,
      multi: true,
    },
    Meta,
    { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
    { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
